import encodeBase64 from '../encodeBase64';

//en orden alfabético
const accountInfo = '/account-info';
const accountSection = '/account';
const profileContacts = '/contacts';
const contact = '/contact';
const cookieConsent = '/cookie-consent';
const fastCheckIn = '/fast-check-in';
const forgotPassword = '/forgot-my-password';
const landingPrivate = '/owner-portal';
const landingPublic = '/';
const login = '/login';
const paymentTerms = '/payment-terms';
const privacyPolicy = '/privacy-policy';
const serviceDesk = '/service-desk';
const settings = '/settings';
const signUp = '/sign-up';
const contactForm = `${contact}/contact-form`;
const propertyList = '/your-properties';
const propertyDetailBase = '/your-property';
const propertyDetail = (id: string | number) => {
    const encodedId = encodeBase64(id);
    return `${propertyDetailBase}/${encodedId}`;
};
const taxes = '/taxes';
const supplements = '/supplements';
const contracts = '/contracts';
const zinantisSection = '/zinantis';
const zinantisMembers = '/members';
const zinantisChannelManagers = '/channel-managers';
const zinantisConnectionRequests = '/connection-requests';
const pageNotFound = '/not-found';
const booking = '/your-bookings';
const ari = '/ari';
const stopSales = '/stop-sales';

const zitoneo = '/zitoneo';
const zitoneoHotelsContent = `/hotels-content`;
const zitoneoHotelServices = (idSupplierHotel: string) =>
    `${zitoneo}${zitoneoHotelsContent}/${encodeBase64(
        idSupplierHotel
    )}/content/editor/hotel/services`;

export default {
    accountInfo,
    accountSection,
    ari,
    booking,
    contact,
    contactForm,
    cookieConsent,
    fastCheckIn,
    forgotPassword,
    landingPrivate,
    landingPublic,
    login,
    pageNotFound,
    paymentTerms,
    privacyPolicy,
    serviceDesk,
    settings,
    signUp,
    stopSales,
    taxes,
    supplements,
    contracts,
    propertyList,
    propertyDetail,
    zinantisSection,
    zinantisMembers,
    zinantisChannelManagers,
    zinantisConnectionRequests,
    zitoneo,
    zitoneoHotelsContent,
    zitoneoHotelServices,
    profileContacts,
};
